export const SEARCH_DROPDOWN_BI_LOCATION = 'search_dropdown';
